@import '~@union-investment/global-resources/src/styles/solid-design-system';

:host {
  sd-dialog::part(panel) {
    padding: $sd-spacing-0;
    width: 600px;
  }

  sd-dialog::part(footer) {
    margin: $sd-spacing-0;
    padding: $sd-spacing-0;
  }

  .inner-container {
    display: flex;
    flex-direction: column;
    gap: $sd-spacing-4;
  }

  .buttons {
    display: flex;
    gap: $sd-spacing-2;
    justify-content: flex-end;
  }

  .hidden {
    display: none;
  }

  .label {
    color: $sd-textColor-primary-DEFAULT;
    font-weight: $sd-fontWeight-bold;
  }

  .sticky {
    position: sticky;
    bottom: $sd-spacing-0;
  }

  .alert {
    display: flex;
    justify-content: space-between;
    padding: $sd-spacing-3 $sd-spacing-4;

    sd-icon {
      font-size: $sd-fontSize-xl;
      flex-shrink: 0;
    }

    &__message {
      display: flex;

      sd-icon {
        margin-right: $sd-spacing-2;
      }
    }

    &--danger {
      background-color: #ffc8c8;
    }

    &--success {
      background-color: $sd-borderColor-success;
    }
  }
}
